module.exports = __webpack_public_path__ + "img/banner7.757b7bb8.png";